
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class RightTurn extends Vue {

    @Prop({required: false})
    circling!: boolean;

    @Prop({required: false})
    extendBegin!: boolean;

    @Prop({required: false})
    returnLevel!: number;

    pageWidth = 0;
   
    created() {
        window.addEventListener("resize", this.windowEventHandler);
    }

    destroyed() {
        window.removeEventListener("resize", this.windowEventHandler);
    }

    public windowEventHandler() {
        let fraction = 20 
        if(this.extendBegin) fraction = 10
        this.pageWidth = (document.documentElement.clientWidth-1700)/fraction
        var extendedTrail = document.getElementById('extended-trail-top-'+this.returnLevel);
        if(extendedTrail)
            extendedTrail.style.setProperty('--extendedtraillength', this.pageWidth +'px')
    }

    mounted(){
        this.windowEventHandler()
    }


}
